import { RootState } from '@/store/types'
import { GetterTree } from 'vuex'
import { LandingPageState } from './types'

export const getters: GetterTree<LandingPageState, RootState> = {}
